/*
 * @Author: yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-06-24 14:08:54
 * @LastEditors: yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-07-22 20:39:22
 * @FilePath: \mpc-2\features\mpc-common\src\features\EquityFormTable\DiffTable\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { localPx2rem } from "#utils";
import { Select, Space, Tag } from "@bedrock/components";
import { ProTablePlus } from "@bedrock/eed-react";
import React, { useEffect, useMemo, useState } from "react";
import NoData from "@bedrock/components/es/Empty/images/small/NoData";
import styles from './index.less';
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

const supplierContentClassName = {
  '-1': 'table-text-normal',
  '0': 'table-text-add',
  '1': 'table-text-delete',
  '2': 'table-text-change',
}

const DiffTable = ({
  value
}) => {
  const [selectItem, setSelectItem] = useState<any>()
  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      width: localPx2rem(48),
      render: (_, record, index) => <div className={cx(supplierContentClassName[record.diff_type])}>{index + 1}</div>,
      
    },
    {
      title: '权益内容',
      dataIndex: 'supplier_content',
      className: 'fw-bold',
      render: (text, record) => {
        return <div>
          {record.diff_type !== 1 && <div className={cx(supplierContentClassName[record.diff_type])}>{text}</div>}
          {[1, 2].includes(record.diff_type) && <div className={cx('table-text-delete')}>{record.actual_content}</div>}
        </div>
      }
    },
  ];
  const optionList = useMemo(() => {
    return value?.sort?.(v => v.winning ? -1 : 1)
  },[value])

  useEffect(() => {
    setSelectItem(optionList?.[0]);
  }, [optionList])

  return <div style={{ width: '100%' }}>
    <div className={cx('diff-table__header')}>
      <Space size='xSmall'>
        <span>供应商:</span>
        <Select
          style={{ width: localPx2rem(240) }}
          options={optionList?.map?.(v => {
            return {
              name: v.supplier_full_name,
              winning: v.winning,
              value: v.demand_supplier_id,
            }
          })}
          dropdownStyle={{ width: localPx2rem(300) }}
          renderLabel={(option) => {
            return <Space className={cx('supplier-option-name')} size={[4, 4]} align='center'>
              {option.name}
              {option.winning && <Tag color="light-green" className={cx('supplier-option-tag')} size="small" text="中选" />}
            </Space>
          }}
          renderSelectedItem={(option) => {
            return <div>{option.name}</div>;
          }}
          onChange={(v) => {
            setSelectItem(value?.find?.(item => item.demand_supplier_id === v))
          }}
          value={selectItem?.demand_supplier_id}
        />
        {selectItem?.winning && <Tag color="light-green" size="small" text="中选" />}
      </Space>
      <Space>
        <Space size='xSmall'><span className={cx('change')} ></span><span className={cx('change-text')} >变更</span></Space>
        <Space size='xSmall'><span className={cx('add')} ></span><span className={cx('change-text')}>新增</span></Space>
        <Space size='xSmall'><span className={cx('delete')} ></span><span className={cx('delete-text')}>删除</span></Space>
      </Space>
    </div>

    <ProTablePlus
      style={{ width: '100%' }}
      scroll={{ 'x': 'max-content' }}
      data={selectItem?.diff_rights_value_dtos || []}
      columns={columns}
      emptyText={
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
          <NoData />
          <div style={{ color: '#878A99' }}>暂无数据</div>
        </div>
      }
    />
  </div>
}

export default DiffTable;